import { Step } from "react-joyride";
export const promptingTutorialSteps: Step[] = [
    // Introduction
    {
        target: "body",
        content:
            "Welcome to the Prompting Tutorial! Let's explore how to create effective prompts.",
        placement: "center",
        isFixed: true,
        disableBeacon: true,
    },
    // Prompt Input - Positive Language
    {
        target: "#simplePrompt",
        content:
            "In the main prompt, focus on what you want to see. Avoid using negative phrases like 'don't include.'",
        placement: "top",
    },
    // Prompting Styles for Different Models
    {
        target: "#simplePrompt",
        content:
            "Prompting Styles: For Flux Models, Use detailed sentences and be descriptive (e.g., 'fierce warrior on a battlefield with glowing sword')",
        placement: "top",
    },
    {
        target: "#simplePrompt",
        content:
            "For other models, use keywords with weighting. e.g., 'warrior, armor, (sword:1.5), battlefield, storm clouds'). Experiment to see what works best!",
        placement: "top",
    },
    // Word Weighting Examples
    {
        target: "#simplePrompt",
        content:
            "Emphasis is between 0 and 2 with 1 being default. Increase emphasis: (dragon:2) Decrease emphasis: (hat:0.5). Weighting puts more focus on specific words.",
        placement: "top",
    },
    // Best Practices
    {
        target: "#simplePrompt",
        content:
            "Best Practices: Be specific and clear. Don't start with 'Create a ...'. Use vivid descriptions. Avoid vague terms. Don't mention unwanted elements here.",
        placement: "top",
    },
    // Common Mistakes
    {
        target: "#simplePrompt",
        content:
            "Avoid These Mistakes: Including negatives in the main prompt. Overusing word weighting. Neglecting the Negative Prompt.",
        placement: "top",
    },
    // Negative Prompt Input - Proper Use
    {
        target: ".negativePrompt",
        content:
            "Use the Negative Prompt to specify what you don't want. List keywords separated by commas. Try not to place too many negatives in here.",
        placement: "top",
    },
    // Negative Prompt Examples and Tips
    {
        target: ".negativePrompt",
        content:
            "Examples:'blurry, low-resolution, cartoonish, red hat' *Tip:* This helps the AI exclude unwanted elements.",
        placement: "top",
    },
    // Generate Button
    {
        target: ".joyride-generate-button",
        content:
            "Ready to see your creation? Click here to generate the image!",
        placement: "top",
    },
    // Conclusion
    {
        target: "body",
        content:
            "Great job! Feel free to experiment and have fun creating amazing images.",
        placement: "center",
        isFixed: true,
    },
];
